import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Employee from "./Employee";
import Provider from "./Provider";
import Client from "./Client";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#F7FAFF",
  },
}));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const User = (props) => {
  const classes = useStyles();

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
        >
          <Tab label="Empleados" {...a11yProps(0)} />
          <Tab label="Proveedores" {...a11yProps(1)} />
          <Tab label="Clientes" {...a11yProps(2)} />
        </Tabs>
      </AppBar>

      <Employee value={value} index={0}></Employee>
      <Provider value={value} index={1}></Provider>
      <Client value={value} index={2}></Client>
    </div>
  );
};

export default User;
